import { render, staticRenderFns } from "./FrontHeader.vue?vue&type=template&id=054dad42&"
import script from "./FrontHeader.vue?vue&type=script&lang=js&"
export * from "./FrontHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports